"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hasReactions ? _c('div', {
    staticClass: "kiwi-reactions"
  }, _vm._l(_vm.reactions, function (nicks, emoji) {
    return _c('span', {
      key: emoji,
      staticClass: "kiwi-reaction",
      class: {
        'kiwi-reaction--mine': _vm.isMine(nicks)
      },
      attrs: {
        "title": nicks.join(', ')
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggle(emoji);
        }
      }
    }, [_vm._v(_vm._s(emoji) + " "), _c('span', {
      staticClass: "kiwi-reaction-count"
    }, [_vm._v(_vm._s(nicks.length))])]);
  }), 0) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];